<mat-card class="daxa-card error-card mb-25 pt-0 border-radius bg-white border-none d-block text-center">
    <mat-card-content style="padding-top: 1rem;">
        <h3>
            OOPS! 404 Page Not Found!
        </h3>
        <p>
            But no worries! Our team is looking ever where while you wait safely.
        </p>
        <a mat-button routerLink="/dashboard">
            Back to Home
        </a>
    </mat-card-content>
</mat-card>